import {Injectable} from '@angular/core';

import {SwUpdate} from '@angular/service-worker';

import {ModalService} from './modal.service';
import {ConfirmConfiguration} from '../models/modal/confirm-configuration';
import {ModalTypes} from '../models/modal/modal-types';
import {environment} from '../../environments/environment';
import {filter} from 'rxjs/operators';
import {NavigationEnd, Router} from '@angular/router';
import {from, take} from 'rxjs';

@Injectable()
export class AppUpdateService {
    private updateAvailable = false;
    private externalPage = false;
    private modalTimer: any;

    constructor(private swUpdate: SwUpdate, private modalService: ModalService, private router: Router) {
        if ((!environment.production && !environment.labs) || !swUpdate.isEnabled) {
            return;
        }

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.externalPage = event.url.includes('/widget/');

                if (this.updateAvailable) {
                    this.updateAvailable = false;
                    from(this.swUpdate.activateUpdate())
                        .subscribe(() => document.location.reload());
                }
            });

        this.checkForUpdate();

        this.swUpdate.versionUpdates
            .pipe(filter(m => m.type === 'VERSION_READY'))
            .subscribe(() => {
                this.updateAvailable = true;

                if (this.externalPage) {
                    from(this.swUpdate.activateUpdate())
                        .subscribe(() => document.location.reload());
                } else {
                    this.scheduleModalPrompt();
                }
            });
    }

    private checkForUpdate() {
        if (!this.swUpdate.isEnabled) return;
        this.swUpdate.checkForUpdate()
            .finally(() => setTimeout(() => this.checkForUpdate(), 60 * 1000));
    }

    private scheduleModalPrompt() {
        if (this.modalTimer) {
            clearTimeout(this.modalTimer);
        }

        const configuration = new ConfirmConfiguration();
        configuration.title = 'A new update has been released';
        configuration.message = `
            <p>A new update has been released for COHO. Would you like to reload your browser to enable the update? (Please note that any unsaved data may be lost).</p>
            <p>If you are busy, you should carry on and simply refresh your browser when it is convenient.</p>`;
        configuration.yesLabel = 'Refresh';
        configuration.noLabel = 'Do it later';
        configuration.confirmCallback
            .pipe(take(1))
            .subscribe(() => {
                from(this.swUpdate.activateUpdate())
                    .subscribe(() => document.location.reload());
            });

        this.modalTimer = setTimeout(() => {
            this.modalService.openModal(ModalTypes.CONFIRM_ITEM, configuration);
        }, 10 * 60 * 1000); // 10 minutes
    }
}
